import { Component, OnInit, Inject } from '@angular/core';
import { environment } from '../environments/environment';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { StorageService } from '../services/storage-service';
import { OrgSettingsService } from './org-settings.service';
import { ImageUploadDto } from '../DTOs/Organisations/Models/ImageUploadDto';
import { ImageResultDto } from '../DTOs/Organisations/Models/ImageResultDto';
import { OrganizationLogoDto } from '../DTOs/Organisations/Models/OrganizationLogoDto';

@Component({
    selector: 'upload-logo-dialog',
    templateUrl: './upload-logo.dialog.html',
    styleUrls: ['./upload-logo.dialog.css'] ,
  })


export class UploadLogoDialog implements OnInit {

  private imageSrc: string = '';
  public ShowLoading: boolean = false;
  public messageErr: string = "";
  public ShowErr: boolean = false;
  public MimeType: string = "image/jpeg";
  public FileName: string = "logo.jpg";

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
      public storageService: StorageService,
      public dialogRef: MatDialogRef<UploadLogoDialog>) {}


  ngOnInit(): void {

  }

    onNoClick(): void {

      this.dialogRef.close();
    }

    onSaveClick(): void {

      this.ShowLoading = true;
      this.ShowErr = false;
      this.messageErr = "";
      let imageUrl: string = "";

      let image: ImageUploadDto = new ImageUploadDto();
      image.ImageBase64 = this.imageSrc.split(',')[1];
      
      image.FileName = this.FileName;
      image.MimeType = this.MimeType;

      if (environment.debug_mode) {
        //console.log("saving image: " + JSON.stringify(image));
      }

      this.storageService.UploadImageToStorage(image)
        .subscribe(
          (response: ImageResultDto) => {

            imageUrl = response.ImageUrl;

            if (environment.debug_mode) {
              console.log("Image Saved!");
              console.log("response: " + JSON.stringify(response));
              console.log("imageUrl: " + imageUrl);
            }

            
            this.dialogRef.close({url: response.ImageUrl, mimeType: this.MimeType});

            this.ShowLoading = false;


          }

          ,
          (error) => {
            this.messageErr = <string>error.message;
            this.ShowLoading = false;
            this.ShowErr = true;
            console.error(error);
          });

    }

  handleInputChange(e): void {

    this.ShowLoading = true;

    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];

    if (environment.debug_mode) {
      console.log("UploadLogoDialog, file:" + file);
    }

    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    this.FileName = file.name;
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }
  _handleReaderLoaded(e): void {

    let reader = e.target;
    this.imageSrc = reader.result;

    this.ShowLoading = false;

    if (environment.debug_mode) {
      console.log(this.imageSrc);
    }
  }

  }

